import { forwardRef, ReactNode } from "react";

import {
  getPlaceholderText,
  renderFormLabel,
} from "../../formik-form-components/FormikFormLine/constants";
import * as styledElements from "../../formik-form-components/FormikFormLine/FormikFormLineStyles";
import { BindNumber, BindString } from "../../../utils/hooks/inputs";

interface FormLineProps {
  label?: string;
  labelComponent?: ReactNode;
  name: string;
  isRequired?: boolean;
  bind?: BindString | BindNumber;
  type?: string;
  styleProps?: object;
  placeholder?: string;
  disabled?: boolean;
  autoFocus?: boolean;
}

const FormLine = forwardRef<HTMLInputElement, FormLineProps>(function FormLine(
  {
    label,
    labelComponent,
    name,
    isRequired = true,
    bind,
    type = "text",
    styleProps,
    placeholder,
    disabled = false,
    autoFocus,
  },
  ref,
) {
  const placeholderText = getPlaceholderText(isRequired, placeholder);

  return (
    <styledElements.Container style={{ ...styleProps }} disabled={disabled}>
      {renderFormLabel(name, label, labelComponent)}
      <input
        placeholder={placeholderText}
        type={type}
        name={name}
        id={name}
        disabled={disabled}
        {...bind}
        ref={ref}
        autoFocus={autoFocus}
      />
    </styledElements.Container>
  );
});

export default FormLine;
